import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './menu.module.scss';
import PrimaryMenu from './PrimaryMenu';
import SecondaryMenu from './SecondaryMenu';

const Menu = (props) => {
  const {
    searching,
    active,
    showMobileMenu,
    mobileCollapsedMenu,
    activePrimaryTab,
  } = props;

  const wrapperClasses = classnames(
    styles.wrapper,
    searching && styles.searching,
    !!mobileCollapsedMenu && styles['mobile-collapsed'],
  );

  return (
    <div className={wrapperClasses}>
      <div className={styles.container}>
        <PrimaryMenu
          {...props}
        />
        <SecondaryMenu
          active={active}
          showMobileMenu={showMobileMenu}
          activePrimaryTab={activePrimaryTab}
        />
      </div>
    </div>
  );
};

Menu.propTypes = {
  searching: PropTypes.bool,
  active: PropTypes.string,
  activePrimaryTab: PropTypes.string,
  showMobileMenu: PropTypes.bool,
  mobileCollapsedMenu: PropTypes.string,
};

export default Menu;



// WEBPACK FOOTER //
// ../src/templates/MainNav/Menu/index.js